<template>
  <AuthLayout :isLogoShow="userType" :center="!userType">
    <v-card flat v-if="!userType" slot="form" class="w-100 transparent box">
      <v-card-text class="text-center py-16">
        <h2 class="hidden-sm-and-down mb-4">Start your journey with DriverX</h2>
        <p class="pa-0">
          Revolutionizing the way students, school
          <br class="hidden-sm-and-down" />and instructors connect
        </p>
        <!-- <p>
          Have an account?
          <v-btn
            x-small
            @click="$router.push('/login')"
            text
            class="font-weight-bold"
            >Login</v-btn
          >
        </p> -->

        <p class="mt-10 mb-2 text-left">Continue as a</p>
        <div class="btn-row">
          <v-btn
            small
            ref="instructorRef"
            :class="userContinue === 'Instructor' ? 'active' : ''"
            @click="signupUserHandle($event, 'Instructor')"
          >
            <div class="icon-box bg-green">
              <i class="icon-education-cap"></i>
            </div>
            an instructor
          </v-btn>
          <v-btn
            small
            ref="studentRef"
            :class="userContinue === 'Student' ? 'active' : ''"
            @click="signupUserHandle($event, 'Student')"
          >
            <div class="icon-box bg-yellow">
              <i class="icon-book"></i>
            </div>
            a student
          </v-btn>
        </div>
        <div class="d-flex justify-space-between reverse align-center">
          <div class="mb-3 mt-3">
            Have an account?
            <v-btn
              x-small
              @click="$router.push('/login')"
              text
              class="font-weight-bold"
              >Login</v-btn
            >
          </div>
          <v-btn
            small
            class="custom-btn"
            @click="userTypeHandle"
            :disabled="userContinue === ''"
            >Continue</v-btn
          >
        </div>
        <!--        <social-signin
          :signinSocial="signinSocial"
          :userTypeDialog="userTypeDialog"
          :fbLoading="fbLoading"
          :goLoading="goLoading"
          :appleLoading="appleLoading"
        />-->
      </v-card-text>
      <!--      <v-toolbar v-if="userType ===''" flat class="hidden-sm-and-up transparent logoAPPP">
        <v-spacer />
        <router-link to="/">
          <img
            alt="logo"
            :src="require('@/assets/img/logo-black.png')"
            width="100"
          />
        </router-link>
        <v-spacer />
      </v-toolbar>-->
    </v-card>
    <SignupForm
      v-if="userType"
      slot="form"
      :userType="userType"
      :handleAuth="handleAuth"
      @setUserType="updateUserTypeState"
    />
    <AuthLeftContent slot="content" />
  </AuthLayout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Parse from 'parse'
import AuthLayout from '@/components/auth/AuthLayout'
import SignupForm from '@/components/auth/SignupForm'
import AuthLeftContent from '@/components/auth/AuthLeftContent'
const hello = require('hellojs/dist/hello.all.min.js')

export default {
  props: {
    handleAuth: Function
  },
  components: {
    AuthLayout,
    SignupForm,
    AuthLeftContent
  },
  data () {
    return {
      userType: '',
      userContinue: '',
      userTypeDialog: false,
      isSubmitting: false,
      fbLoading: false,
      goLoading: false,
      appleLoading: false
    }
  },
  computed: mapGetters(['isLogged', 'user']),
  methods: {
    ...mapActions([
      'getUser',
      'toggleDialog',
      'toggleTour',
      'updateUser',
      'setUserTypeHeader'
    ]),
    updateUserTypeState (ty) {
      this.userType = ty
      this.setUserTypeHeader(ty)
      this.userContinue = ty
    },
    userTypeHandle (e) {
      console.log('user type handle ==', this.userContinue)
      if (this.userContinue === 'Student') {
        this.setUserTypeHeader(this.userContinue)
        this.userType = this.userContinue
        // this.signupViaZipCode()
      } else {
        this.setUserTypeHeader(this.userContinue)
        this.userType = this.userContinue
      }
    },
    signupUserHandle (e, ut) {
      this.userContinue = ut
    },
    signupViaZipCode () {
      this.$router.push({ name: 'zipcode' })
    },
    async signinSocialWeb (network) {
      hello(network)
        .login()
        .then(() => {
          const authRes = hello(network).getAuthResponse()
          this.access_token = authRes.access_token
          /*
            performs operations using the token from authRes
          */
          hello(network)
            .api('me', {
              scope: 'email',
              force: true
            })
            .then((json) => {
              console.log(json)
              const profile = json
              const id = profile.id
              const email = profile.email
              const firstName = profile.first_name || ''
              const lastName = profile.last_name || ''
              const thumbnail = profile.thumbnail || ''
              let myAuthData = {}
              if (network === 'google') {
                this.goLoading = true
                myAuthData = {
                  id: id,
                  access_token: this.access_token
                }
              } else if (network === 'facebook') {
                this.fbLoading = true
                myAuthData = {
                  access_token: this.access_token,
                  id: profile.id // Required field. Used to uniquely identify the linked account.
                }
              }
              this.loginWith(
                myAuthData,
                id,
                firstName,
                lastName,
                email,
                thumbnail
              )
            })
        })
    },
    async signinSocialMobile (network) {
      if (network === 'facebook') {
        this.fbLoading = true
        window.facebookConnectPlugin.login(
          ['public_profile', 'email'],
          this.fbLoginSuccess,
          function loginError (error) {
            console.log(error)
            this.fbLoading = false
            this.toggleDialog({
              status: true,
              title: 'Error',
              message: 'Something went wrong, please try again.'
            })
          }
        )
      } else if (network === 'apple') {
        this.appleLoading = true
        window.cordova.plugins.SignInWithApple.signin(
          { requestedScopes: [0, 1] },
          (obj) => {
            const id = obj.user
            const email = obj.email
            const firstName = obj.fullName.givenName || ''
            const lastName = obj.fullName.familyName || ''

            const myAuthData = {
              access_token: obj.identityToken,
              id: id // Required field. Used to uniquely identify the linked account.
            }
            this.loginWith(myAuthData, id, firstName, lastName, email)
          },
          (err) => {
            this.appleLoading = false
            console.log('error: ' + err)
            this.toggleDialog({
              status: true,
              title: 'Error',
              message: 'Something went wrong, please try again.'
            })
          }
        )
      } else {
        /** Android */
        this.goLoading = true
        window.plugins.googleplus.login(
          {
            scopes:
              'https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile', // optional, space-separated list of scopes, If not included or empty, defaults to `profile` and `email`.
            webClientId:
              '814141650586-bkibmuvli7b2o5kqaq0itdqrlm3omdv9.apps.googleusercontent.com', // optional clientId of your Web application from Credentials settings of your project - On Android, this MUST be included to get an idToken. On iOS, it is not required.
            offline: true // optional, but requires the webClientId - if set to true the plugin will also return a serverAuthCode, which can be used to grant offline access to a non-Google server
          },
          (obj) => {
            console.log(obj)
            const id = obj.userId
            const email = obj.email
            const firstName = obj.givenName || ''
            const lastName = obj.familyName || ''
            const thumbnail = obj.thumbnail || ''

            const myAuthData = {
              access_token: obj.accessToken,
              id: id // Required field. Used to uniquely identify the linked account.
            }
            this.loginWith(
              myAuthData,
              id,
              firstName,
              lastName,
              email,
              thumbnail
            )
          },
          (msg) => {
            this.goLoading = false
            console.log('error: ' + msg)
            this.toggleDialog({
              status: true,
              title: 'Error',
              message: 'Something went wrong, please try again.'
            })
          }
        )
      }
    },
    async fbLoginSuccess (userData) {
      alert(JSON.stringify(userData))
      this.fbLoading = false
      await window.facebookConnectPlugin.getAccessToken((token) => {
        console.log(token)
        /** Get users information */
        window.facebookConnectPlugin.api('/me', function (me) {
          console.log(me)
          alert('Verification is yet to be done')
          // this.fbLoading = false;
          // alert(JSON.stringify(me));
        })

        // window.facebookConnectPlugin.api(
        //   "/me?fields=id,name,email",
        //   ["public_profile", "email"],
        //   (response) => {
        //     alert("Success");
        //     alert(
        //       response.id +
        //         " | " +
        //         response.name +
        //         " | " +
        //         response.email +
        //         " | "
        //     );
        //     let email = "";
        //     let firstName = "";
        //     let lastName = "";
        //     let id = userData.authResponse.userID;

        //     let myAuthData = {};
        //     myAuthData = {
        //       access_token: token,
        //       id: id, // Required field. Used to uniquely identify the linked account.
        //     };
        //     this.loginWith(myAuthData, id, firstName, lastName, email);
        //   },
        //   (error) => {
        //     alert(JSON.stringify(error));
        //     console.log(error);
        //     this.goLoading = false;
        //     this.fbLoading = false;
        //   }
        // );
      })
    },
    /** Social log in */
    async loginWith (authData, id, firstName, lastName, email, thumbnail) {
      const provider = {
        authenticate: (options) => {
          // Some code to get retrieve authData
          // If retrieved valid authData, call success function with the data
          options.success(this, {
            id: id
          })
          // You can also handle error
          options.error(this, {})
        },
        restoreAuthentication () {
          return true
        },

        getAuthType () {
          return 'socialAuth'
        },

        getAuthData () {
          return {
            authData
          }
        }
      }

      Parse.User._registerAuthenticationProvider(provider)
      const user = new Parse.User()
      await user.linkWith(provider.getAuthType(), provider.getAuthData()).then(
        async () => {
          const currentUser = Parse.User.current()
          /** we should not update them but insert them for the first time, since we have option to change password and email */
          if (
            typeof currentUser.get('email') === 'undefined' ||
            currentUser.get('email') === ''
          ) {
            await this.updateUser({
              firstName: firstName,
              lastName: lastName,
              email: email,
              username: email,
              emailVerified: true,
              customEmail: email,
              profilePicture: thumbnail,
              profileNotCompleted: true,
              status: true
            })

            const nData = {
              firstName: firstName,
              lastName: lastName,
              email: email,
              username: email,
              customEmail: email,
              profilePicture: thumbnail,
              profileNotCompleted: true,
              status: true,
              user: currentUser.id
            }

            await Parse.Cloud.run('updateUser', nData).then(
              (res) => {
                console.log(res)
              },
              (error) => {
                console.log(error)
              }
            )

            if (email !== '') {
              /** Add contact to mailgun */
              const cData = {
                firstName: firstName,
                lastName: lastName,
                email: email,
                phone: ''
              }

              Parse.Cloud.run('addContactToMailChimp', cData).then(
                (res) => {
                  console.log(res)
                },
                (error) => {
                  console.log(error)
                }
              )
            }

            /** for now, put them in pending status until we figure out  how to handle to roles and rest of the profile */
            const data = {
              user: currentUser.id,
              accountname: 'Pending',
              admin: false
            }

            await Parse.Cloud.run('addUserToRole', data).then(() => {
              setTimeout(() => {
                this.fbLoading = false
                this.goLoading = false
                this.appleLoading = false
                // const redirectPath = "/get-started";
                // this.$router.push(redirectPath);
                /** Ask them to select a type of user */
                this.userTypeDialog = true
              }, 2000)
            })
          } else {
            const currentUser = Parse.User.current()
            var query = new Parse.Query(Parse.Role)
            query.containedIn('name', ['User'])
            query.equalTo('users', Parse.User.current())
            query.first().then((role) => {
              if (currentUser.get('status')) {
                if (!role) {
                  /** it might be the case that the social logged in user didn't complete userType and this is
                   * why on 2nd log in they are here. So they need to complete their selection
                   */
                  // localStorage.clear();
                  // Parse.User.logOut();
                  // this.alertMessage = "You are not authorized to login";
                  // this.toggleDialog({
                  //   status: true,
                  //   title: this.errorType,
                  //   message: this.alertMessage,
                  // });
                  this.userTypeDialog = true
                } else {
                  const userType = role.get('name').toLowerCase().trim()
                  localStorage.setItem('userType', userType)
                  this.getUser()
                }
              } else {
                this.alertMessage = 'Your account has been disabled'
                this.toggleDialog({
                  status: true,
                  title: this.errorType,
                  message: this.alertMessage
                })
                Parse.User.logOut()
              }
            })
          }
        },
        (error) => {
          console.log(error)
          this.alertMessage = 'Something went wrong, please try again'
          this.toggleDialog({
            status: true,
            title: this.errorType,
            message: this.alertMessage
          })
        }
      )
    },

    async signinSocial (network) {
      console.log({ network })
      if (typeof window.device !== 'undefined') {
        this.signinSocialMobile(network)
      } else {
        this.signinSocialWeb(network)
      }
    }
  },
  async created () {
    await this.getUser()
    if (this.isLogged) {
      if (localStorage.getItem('userType') === 'student') {
        if (this.user.get('getStartedDone')) {
          this.$router.push({ name: 'StudentDashboard' })
        } else {
          this.$router.push({ name: 'GetStarted' })
        }
      } else {
        this.$router.push({ name: 'Dashboard' })
      }
    } else {
      if (this.$route && this.$route.query) {
        // Access the 'package' query parameter from the URL
        const packageValue = this.$route.query.package
        const type = this.$route.query.type

        // Check if URL contains package parameter and type is student
        if (packageValue && type === 'student') {
          this.userContinue = 'Student'
          this.setUserTypeHeader('Student')
          this.userType = this.userContinue
          console.log('Package value:', packageValue)
          console.log('type :', type)
        } else if (packageValue) {
          // Package parameter exists but type is not student, reset URL
          console.log('Package parameter found but type is not student, resetting URL')
          // this.$router.replace({ name: "Signup" });
        } else if (type === 'student') {
          // Only type parameter exists, proceed normally
          this.userContinue = 'Student'
          this.setUserTypeHeader('Student')
          this.userType = this.userContinue
          console.log('type :', type)
        } else {
          // console.log("Package parameter not found in URL.");
        }
      } else {
        console.log('Route information not available.')
        // this.$router.replace({ name: "Signup" });
      }
    }
  }
}
</script>
<style>
.v-application .primary.active {
  border: 1px solid red !important;
}
</style>
